var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCurrency(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H40V40H0z",
    transform: "translate(-173 -503) translate(105 119) translate(24 376) translate(44 8)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    fill: "#A5A5A5",
    transform: "translate(-173 -503) translate(105 119) translate(24 376) translate(44 8) translate(4 4)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "M16.8 26.335v-2.637c1.62-.178 2.86-.648 3.72-1.41.858-.761 1.287-1.73 1.287-2.904 0-.948-.295-1.75-.887-2.407-.591-.656-1.657-1.28-3.196-1.871l-.924-.353V10.33c1.256.097 2.52.397 3.792.9l.887-2.225c-1.474-.607-3.034-.94-4.679-.996V6.003h-1.616v2.042c-1.49.154-2.672.592-3.543 1.313-.87.72-1.306 1.64-1.306 2.758 0 1.045.306 1.922.918 2.631.611.71 1.581 1.319 2.91 1.83l1.021.376v4.545c-.737-.008-1.572-.127-2.503-.358-.932-.231-1.746-.517-2.443-.857v2.564c1.288.584 2.937.891 4.946.924v2.564H16.8zm-1.616-12.177c-.753-.3-1.274-.604-1.562-.911-.287-.308-.431-.693-.431-1.155 0-.446.17-.818.51-1.118.34-.3.835-.498 1.483-.596v3.78zm1.616 7.243v-3.877c.77.284 1.319.578 1.647.881.328.304.492.691.492 1.161 0 1.005-.713 1.616-2.139 1.835z",
    transform: "translate(-173 -503) translate(105 119) translate(24 376) translate(44 8) translate(4 4)"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCurrency);
export default __webpack_public_path__ + "static/media/currency.4405ba2c568d37ace873190e320b4b09.svg";
export { ForwardRef as ReactComponent };